var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { Button } from '../../../../atoms/Button/Button';
import { TextArea } from '../../../../molecules/inputs/form/TextInput/TextInput';
import { InlineNotification } from '../../../../molecules/InlineNotification/InlineNotification';
import { ConfirmDialog } from '../../../../molecules/ConfirmDialog/ConfirmDialog';
const baseClass = 'qmb-ui-integration-sync-status-panel__requeue-form';
const SUCCESSFUL_OUTCOMES = new Set(['enqueued']);
export function RequeueForm({ onResend, labels }) {
    const [reason, setReason] = useState('');
    const [validationError, setValidationError] = useState(null);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [result, setResult] = useState(null);
    const [submitError, setSubmitError] = useState(null);
    const requestConfirmation = () => {
        if (reason.trim().length === 0) {
            setValidationError(labels.reasonRequiredError);
            return;
        }
        setValidationError(null);
        setConfirmOpen(true);
    };
    const submitResend = () => __awaiter(this, void 0, void 0, function* () {
        setSubmitting(true);
        setSubmitError(null);
        try {
            const outcome = yield onResend(reason);
            setResult(outcome);
            setConfirmOpen(false);
        }
        catch (_a) {
            setSubmitError(labels.resendErrorFallback);
            setConfirmOpen(false); // otherwise the error notification renders behind the still-open dialog
        }
        finally {
            setSubmitting(false);
        }
    });
    return (React.createElement("div", { className: baseClass },
        React.createElement(TextArea, { id: "integration-sync-status-panel-reason", label: labels.reasonLabel, placeholder: labels.reasonPlaceholder, required: true, value: reason, onChange: (event) => setReason(event.target.value), error: validationError !== null && validationError !== void 0 ? validationError : undefined }),
        React.createElement(Button, { variant: "primary", disabled: submitting, onClick: () => {
                requestConfirmation();
            } }, submitting ? labels.submittingLabel : labels.resendButton),
        result && (React.createElement(InlineNotification, { variant: SUCCESSFUL_OUTCOMES.has(result.outcome) ? 'success' : 'warning' }, result.message)),
        submitError && React.createElement(InlineNotification, { variant: "error" }, submitError),
        React.createElement(ConfirmDialog, { isOpen: confirmOpen, title: labels.confirmTitle, description: labels.confirmDescription, loading: submitting, confirmLabel: labels.confirmButton, cancelLabel: labels.cancelButton, onConfirm: () => {
                void submitResend();
            }, onCancel: () => setConfirmOpen(false) })));
}
export default RequeueForm;
